import TextComponent from "../textComponent/TextComponent";
import styles from "./TextHeader.module.css";

const TextHeader = ({ text, containerClass, textClass }) => {
  return (
    <div className={`${containerClass} ${styles.textContainer}`}>
      <TextComponent text={text} textClass={`${styles.text} ${textClass}`} />
    </div>
  );
};

export default TextHeader;
